import React, { memo, forwardRef, MutableRefObject } from "react";
import { messageRelativePastTime } from "../../../actions/messageRelativePastTime";
import Avatar from "../../avatar";
import ReadInfo from "../readInfo";
import { openPlayerPopup } from "../../../actions";
import { MessageProps } from "../types";

const MatchMessage = memo(
	forwardRef(
		(
			{ message, partners, partner, lastReadByPartners, userId }: MessageProps,
			ref: MutableRefObject<HTMLDivElement>
		) => {
			const relativePastTimeString = messageRelativePastTime(message.createdAt);
			return (
				<div
					className={`item message${message.text.deleted! ? " deleted" : ""}`}
					ref={ref}
					data-id={message.messageId}
				>
					<div className="itemImage" onClick={openPlayerPopup.bind(null, partner.userId)}>
						<Avatar photoUrl={partner.photoUrl} />
					</div>
					<div className="itemBody">
						<div className="messageBody" title={relativePastTimeString}>
							<div className="text">{message.text.payload.messagePayload.message}</div>
						</div>
						{lastReadByPartners ? (
							<ReadInfo
								partners={partners}
								lastReadByPartners={lastReadByPartners}
								userId={userId}
								senderId={message.senderId}
							/>
						) : null}
					</div>
				</div>
			);
		}
	)
);

MatchMessage.displayName = "MatchMessage";
export default MatchMessage;
